import HttpHelper from "../../../helpers/httpHelper";

const USER_API_URL = process.env.REACT_APP_USER_API_URL;

class VIPCircleAPI {
    static CreateVIPCircle(req) {
        let url = `${USER_API_URL}/vip-circle`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static UpdateVIPCircle(req) {
        let url = `${USER_API_URL}/vip-circle/` + req._id;
        return HttpHelper.httpRequest(url, "PUT", {}, req);
    }

    static GetVIPCircles(req) {
        let url = `${USER_API_URL}/vip-circle`;
        return HttpHelper.httpRequest(url, "GET", {}, req);
    }

    static DeleteVIPCircle(req) {
        let url = `${USER_API_URL}/vip-circle/` + req;
        return HttpHelper.httpRequest(url, "DELETE", {});
    }

    static GetMySubscriptions(req) {
        let url = `${USER_API_URL}/vip-circle/subscriptions`;
        return HttpHelper.httpRequest(url, "GET", {});
    }

    static GetVIPCircle(req) {
        let url = `${USER_API_URL}/vip-circle/` + req;
        return HttpHelper.httpRequest(url, "GET", {});
    }

    static GetOtherVIPCircles(userId) {
        let url = `${USER_API_URL}/vip-circle/${userId}/get-by-user`;
        return HttpHelper.httpRequest(url, "GET", {});
    }

    static RequestToJoin(req) {
        let url = `${USER_API_URL}/vip-circle/${req.vip}`;
        delete req.vip;
        return HttpHelper.httpRequest(url, "PATCH", {}, req);
    }

    static CancelRequestToJoin(req) {
        let url = `${USER_API_URL}/vip-circle/cancel/${req.vip}`;
        delete req.vip;
        return HttpHelper.httpRequest(url, "PATCH", {}, req);
    }

    static UpdateStatus(req) {
        let url = `${USER_API_URL}/vip-circle/${req.userId}/guest/${req.vip}?status=${req.status}`;
        return HttpHelper.httpRequest(url, "PATCH", {});
    }
}

export default VIPCircleAPI;
